import React, { useEffect, useRef } from "react";
import * as tf from "@tensorflow/tfjs";
// NEW MODEL
import * as facemesh from "@tensorflow-models/face-landmarks-detection";
import Webcam from "react-webcam";
import { detect } from "./core/streamAndDraw";
import { randomDirArrGenerator } from "./core/randomDirGenerator";
import "./index.css";
import { dataProcessing } from "./core/dataProcessing";
import { measureLimits } from "./configParams";

//Grabar video de la prueba

const test = randomDirArrGenerator();
let isTestFinished = false;
// export let detection;
console.log(test);
let vectors = { mouth: [] };
let diffVectors = { mouth: [] };
const arrOfMovements = [];

function ProofOfLife() {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  // const [loading, setLoading] = useState(true);
  // let loading = true;

  const runFacemesh = async () => {
    // NEW MODEL
    const net = await facemesh.load(
      facemesh.SupportedPackages.mediapipeFacemesh
    );

    // detection =
    setInterval(async () => {
      const detection = await detect(
        net,
        webcamRef,
        canvasRef,
        vectors,
        diffVectors
      );

      if (detection?.vectors?.mouth?.length < measureLimits.upperLimit) {
        dataProcessing(
          detection.vectors,
          arrOfMovements,
          isTestFinished,
          detection.diffVectors,
          test
        );
      } else {
        vectors = { mouth: [] };
        diffVectors = { mouth: [] };
      }
    }, 200);
  };

  useEffect(() => {
    runFacemesh();
  });

  //  Load posenet

  // if (loading) {
  //   return <div>Cargando...</div>;
  // }

  return (
    <div className="App">
      <Webcam ref={webcamRef} className="webcam" />

      <span className="ring" />
      <span className="round_dot" />

      <img
        src={require("./assets/check-circle-solid.svg")}
        alt="checked"
        className="checked"
      />

      {/* <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 9,
            width: 640,
            height: 480,
          }}
        /> */}
    </div>
  );
}

export default ProofOfLife;
